document.addEventListener("DOMContentLoaded", function () {
  const elBundleSaleList = document.querySelectorAll('.js-bundle-sale');
  let priceTotal = 0;

  elBundleSaleList.forEach((elBundleSale) => {
    calcTotal(elBundleSale);
  })
  // calcPostage();

  document.querySelectorAll('.js-bundle-checkbox').forEach((elCheckbox) => {
    const elBundleSale = elCheckbox.closest('.js-bundle-sale');
    elCheckbox.addEventListener('change', () => {
      calcTotal(elBundleSale);
      // calcPostage();
    })
  })

  document.querySelectorAll('.is-bundle-cartin').forEach((elCartin) => {
    const elBundleSale = elCartin.closest('.js-bundle-sale');
    elCartin.addEventListener('click', () => {
      cartIn(elBundleSale);
    })
  })

  // ブラウザバックした時に総額や送料を再計算する
  window.addEventListener("pageshow", function (event) {
    var entries = performance.getEntriesByType("navigation");
    entries.forEach(function (entry) {
      if (entry.type == "back_forward") {
        elBundleSaleList.forEach((elBundleSale) => {
          calcTotal(elBundleSale);
        })
        // calcPostage();
      }
    });
  });
});

class BundleVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    const productId = this.dataset.productId;

    // 価格表示を更新
    const elPrice = document.getElementById(`price-${productId}`);
    elPrice.dataset.price = this.currentVariant.price/100;
    elPrice.innerText = `¥${(this.currentVariant.price/100).toLocaleString()}`;

    // バリエーションID更新
    const elCheckbox = document.getElementById(`checkbox-${productId}`)
    elCheckbox.dataset.variantId = this.currentVariant.id;
    
    this.checkAvailable();

    // 価格計算
    calcTotal(this.closest('.js-bundle-sale'));
    // calcPostage();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  checkAvailable() {
    const elCheckbox = this.closest('.js-bundle-item').querySelector('.js-bundle-checkbox');
    const elSoldoutTxt = this.closest('.js-bundle-item').querySelector('.js-bundle-soldout');
    if (this.currentVariant.available) {
      elCheckbox.disabled = false;
      elCheckbox.checked = true;
      elSoldoutTxt.classList.add('hidden');
    } else {
      elCheckbox.disabled = true;
      elCheckbox.checked = false;
      elSoldoutTxt.classList.remove('hidden');
    }
  }
}
customElements.define('bundle-variant-selects', BundleVariantSelects);

class BundleQuantityInput extends QuantityInput {
  onButtonClick(event) {
    // 元のQuantityInputの処理
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    // 数量に合わせて計算
    calcTotal(this.closest('.js-bundle-sale'));
    // calcPostage();
  }
}
customElements.define('bundle-quantity-input', BundleQuantityInput);


// function calcPostage() {
//   const elPostage = document.querySelector('.js-bundle-postage');

//   if (priceTotal >= 22000) {
//     elPostage.innerText = '無料'
//   } else {
//     let priceNotEnough = 22000 - priceTotal;
//     elPostage.innerText = `あと${priceNotEnough.toLocaleString()}円で送料無料`
//   }
// }

// 個別送料タグがある場合は送料無料の表示をしない
// function checkLargeBox() {
//   console.log('checkLargeBox');
//   const elPostageFree = document.querySelector('.js-bundle-postage-free');
//   const elPostageNotFree = document.querySelector('.js-bundle-postage-not-free');

//   elPostageFree.classList.remove('hidden');
//   elPostageNotFree.classList.add('hidden');

//   document.querySelectorAll('.js-bundle-item').forEach((elItem) => {
//     const isIndividualPostage = elItem.dataset.individualPostage;
//     const isChecked = elItem.querySelector('.js-bundle-checkbox').checked;

//     console.log('isIndividualPostage: ', isIndividualPostage);
//     console.log('isChecked: ', isChecked);

//     if (isIndividualPostage && isChecked) {
//       elPostageFree.classList.add('hidden');
//       elPostageNotFree.classList.remove('hidden');
//     }
//   })
// }

function calcTotal(elBundleSale) {
  priceTotal = 0;
  elBundleSale.querySelectorAll('.js-bundle-item').forEach((elItem) => {
    const elPrice = elItem.querySelector('.js-bundle-price')
    const isChecked = elItem.querySelector('.js-bundle-checkbox').checked;
    const elQuantity = elItem.querySelector('bundle-quantity-input input');
    let quantity = 1;
    if (elQuantity) {
      quantity = elQuantity.value;
    }
    if (isChecked) {
      const price = parseInt(elPrice.dataset.price, 10) * quantity;
      priceTotal += price;
    }
  })
  elBundleSale.querySelectorAll('.js-bundle-total').forEach((elTotal) => {
    elTotal.innerText = '¥' + priceTotal.toLocaleString();
  })

  const resultContent = elBundleSale.querySelectorAll('.js-result-content');
  const resultNone = elBundleSale.querySelectorAll('.js-result-none');
  if (priceTotal == 0) {
    resultContent.forEach((elContent) => {
      elContent.classList.add('hidden');
    })
    resultNone.forEach((elNone) => {
      elNone.classList.remove('hidden');
    })
  } else {
    resultContent.forEach((elContent) => {
      elContent.classList.remove('hidden');
    })
    resultNone.forEach((elNone) => {
      elNone.classList.add('hidden');
    })
  }

  // checkLargeBox();
}

function cartIn(elBundleSale) {
  let items = [];

  const btnCartIn = elBundleSale.querySelectorAll('.is-bundle-cartin');

  btnCartIn.forEach((elCartin) => {
    elCartin.disabled = true;
    elCartin.querySelector('.is-bundle-spinner').classList.remove('hidden');
  })

  elBundleSale.querySelectorAll('.js-bundle-checkbox:checked').forEach((elChecked) => {
    const variantId = elChecked.dataset.variantId;
    // const quantity = elChecked.closest('.js-bundle-item').querySelector('bundle-quantity-input input').value;
    items.push({
      id: variantId,
      // quantity: quantity
    });
  })

  const cartAddData = {
    items: items.reverse()
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'dataType': 'json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(cartAddData)
  })
  .then(() => {
    window.location = "/cart";
  })
  .catch((error) => {
    btnCartIn.forEach((elCartin) => {
      elCartin.disabled = false;
      elCartin.querySelector('.is-bundle-spinner').classList.add('hidden');
    })
    console.error('Error:', error);
  });
}

// document.addEventListener('DOMContentLoaded', function() {
//   // バリアントデータをHTML要素から取得
//   const bundleItems = document.querySelectorAll('.js-bundle-item');
  
//   bundleItems.forEach(item => {
//     // バリアントデータをJSONから取得
//     const variantScript = item.querySelector('script[type="application/json"]');
//     if (!variantScript) return;
    
//     const variants = JSON.parse(variantScript.textContent);
    
//     // セレクトの変更を監視
//     const selects = item.querySelectorAll('.bundle-sale__item-select');
//     selects.forEach(select => {
//       select.addEventListener('change', () => {
//         // すべてのセレクトの選択されたvalueIdを取得
//         const selectedValueIds = Array.from(selects).map(select => {
//           const option = select.options[select.selectedIndex];
//           return option.getAttribute('value-id');
//         });
        
//         // 選択されたvalueIdの組み合わせに一致するバリアントを探す
//         const matchingVariant = variants.find(variant => 
//           variant.option_values.every(optionValue => 
//             selectedValueIds.includes(optionValue.id.toString())
//           )
//         );
        
//         if (matchingVariant) {
//           // checkboxのdata-variant-idを更新
//           const checkbox = item.querySelector('.js-bundle-checkbox');
//           checkbox.dataset.variantId = matchingVariant.id;
          
//           // 価格を更新
//           const priceElement = item.querySelector('.js-bundle-price');
//           if (priceElement) {
//             const formattedPrice = new Intl.NumberFormat('ja-JP', {
//               style: 'currency',
//               currency: 'JPY'
//             }).format(matchingVariant.price);
            
//             priceElement.dataset.price = matchingVariant.price;
//             priceElement.textContent = `${formattedPrice}（税込）`;
//           }
          
//           // 合計金額と送料を再計算
//           calcTotal();
//           // calcPostage();
//         }
//       });
//     });
//   });
// });